/**
 * @description
 */

import { fetchData } from '@umu/umu-fetch';

import Api from '../../../../path';

export interface IInput {
    practice_id: number;
}

export interface IOutput {
    id: number; // 小节id，从所有错题(已收藏)进入此id为0
    title: string; // 小节标题，从所有错题(已收藏)进入此值为空串
    right_num: number; // 答对题目数
    total_num: number; // 总题目数
}

export const donePractice = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.QUESTION_COLLECTION_DONE_PRACTICE, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
